// extracted by css-extract-rspack-plugin
export default {"field":"FormField__field--LMee3","label":"FormField__label--uErfi","note":"FormField__note--opQaN"};